/**
 * シェアボタン
 */
export default class ShareButton extends HTMLElement {

  constructor() {
    super();
    this.favorited = false;
    this.attachShadow({mode: "open"});
    this.shadowRoot.innerHTML =
      `<style>
        button {
          background-color: transparent;
          border: none;
          cursor: pointer;
          outline: none;
          padding: 3px;
          appearance: none;
          box-sizing: border-box;
        }
        button:hover svg {
          opacity: .8;
          transform: scale(1.1);
        }
        button:focus-visible {
          outline: 0.2rem solid rgb(135 173 245);
          outline-offset: 0.3rem;
          box-shadow: 0 0 0 0.3rem rgb(255 255 255),
                      0 0 0.5rem 0.4rem rgb(135 173 245 / .5));
        }
        button.-type-circle {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 50px;
          height: 50px;
          border: 1px solid var(--unico-color-grey03);
          border-radius: 50%;
          background: #fff;
          flex-shrink: 0;
        }
        button svg {
          vertical-align: bottom;
          transition: all .15s ease-in-out 0s;
        }
        [data-tooltip] {
          position: relative;
        }
        [data-tooltip]::before {
          content: attr(data-tooltip);
          position: absolute;
          bottom: 50%;
          right: 0;
          display: block;
          padding: 0.4rem 0.8rem 0.5rem;
          border-radius: 0.2rem;
          background-color: var(--unico-color-grey03);
          color: var(--unico-color-text-secondary);
          font-size: 1rem;
          font-weight: 400;
          line-height: calc(15 / 10);
          text-align: center;
          white-space: nowrap;
          opacity: 0;
          scale: 0.8;
          transition: .15s ease;
        }
        [data-tooltip].is-tooltip-show {
          &::before {
            opacity: 1;
            bottom: 110%;
            scale: 1;
          }
        }
        @media screen and (max-width: 1240px) {
          [data-tooltip]::before {
            right: 50%;
            translate: 50% 0;
          }
        }
      </style>
      <button aria-label="シェアする" type="button" data-tooltip="リンクをコピーしました">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="22" viewBox="0 0 46.752 46.749"><g transform="translate(0 0)"><path d="M46.752,44.974l0-.025V20.975a1.775,1.775,0,1,0-3.55,0V43.2H3.55V20.975a1.775,1.775,0,1,0-3.55,0v24a1.764,1.764,0,0,0,1.237,1.682,1.726,1.726,0,0,0,.537.1h43.2a1.778,1.778,0,0,0,1.777-1.775" fill="#333"/><path d="M23.375,34.749a1.777,1.777,0,0,0,1.774-1.777V6.059L32.3,13.211a1.775,1.775,0,1,0,2.51-2.51L24.634.523A1.687,1.687,0,0,0,24.357.3L24.266.249a1.809,1.809,0,0,0-.213-.114L23.569.02a.777.777,0,0,0-.308-.01l-.489.1a1.306,1.306,0,0,0-.26.121L22.4.292a1.672,1.672,0,0,0-.287.23L11.937,10.7a1.775,1.775,0,0,0,1.253,3.031h0a1.761,1.761,0,0,0,1.256-.521L21.6,6.059V32.972a1.778,1.778,0,0,0,1.775,1.777" fill="#333"/></g></svg>
      </button>`;
  }

  connectedCallback() {
    const button = this.shadowRoot.querySelector("button");
    button.addEventListener("click", async () => {
      try {
        await navigator.share({
          title: document.title,
          url: location.href,
        });
      } catch (e) {
        await navigator.clipboard.writeText(location.href);
        // Web Share API非対応ブラウザ用にフォールバック
        if (!navigator.share) {
          button.classList.add('is-tooltip-show');
          setTimeout(() => {
            button.classList.remove("is-tooltip-show");
          }, 1600);
        }
      }
    });

    const type = this.getAttribute("type");
    if (type) {
      button.classList.add(`-type-${type}`);
    }
  }
}
